import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { RouterModule,RouterOutlet } from '@angular/router';
import { FooterComponent } from '../furniture/footer.component';
import { HeaderComponent } from '../furniture/header.component';
@NgModule({
  exports: [TranslateModule,CommonModule,RouterModule],
  imports: [HttpClientModule],
})
export class SharedTranslateModule {}